<template>
    <el-dialog
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="visible"
        title="Message from Corwin"
        width="500px"
    >
        <div v-for="(message, i) in messages">
            <span v-html="formatMessage(message)"></span>
            <el-divider v-if="i < messages.length - 1" />
        </div>
        <div class="dialog-footer" slot="footer">
            <el-button @click="visible = false" type="primary">OKAY</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        messages: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            visible: false,
        };
    },
    methods: {
        show() {
            this.visible = true;
        },
        formatMessage(message) {
            return Utils.convertTextToHtml(message);
        },
    },
};
</script>

<style scoped></style>
